import { useCallback } from 'react';

import { CATEGORIES } from '@hivebrite/design-system/FontAwesomeIcon';
import { Tooltip } from '@hivebrite/design-system/Tooltip';

import ToolbarButton from 'hb-builder/components/common/Wrapper/components/ToolbarButton';
import { useBuilderContext, useComponentContext } from 'hb-builder/hooks';
import { createNewItem } from 'hb-builder/utils/createNewItem';

const ToolbarDuplicate = ({ tooltipPlace }) => {
  const { addItem } = useBuilderContext();
  const { item } = useComponentContext();

  const handleDuplicateItem = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      const { id, ...newItem } = item;

      addItem({
        direction: 1, // Always duplicate at the bottom of the item
        id,
        item: createNewItem(newItem, { isDuplicate: true }),
      });
    },
    [item],
  );

  const label = __('Duplicate');

  return (
    <Tooltip initialPosition={tooltipPlace} childrenElement={label}>
      <ToolbarButton
        iconType={CATEGORIES.LIGHT}
        iconName="clone"
        onClick={handleDuplicateItem}
        ariaLabel={label}
      />
    </Tooltip>
  );
};

export default ToolbarDuplicate;
